// src/components/site-editor/panels/TypographyPanel.js
import React from 'react';
import { useWebsiteBuilder } from '../../../contexts/WebsiteBuilderContext';
import FontSelector from '../../editors/FontSelector';

// Grid order: Row 1: Playfair Display | Inter
//             Row 2: Lora | Outfit
//             Row 3: Raleway | Montserrat
const FONT_OPTIONS = [
  {
    id: 'playfair',
    name: 'Playfair Display',
    headingFont: 'Playfair Display',
    bodyFont: 'Lato',
    category: 'Classic Serif',
  },
  {
    id: 'inter',
    name: 'Inter',
    headingFont: 'Inter',
    bodyFont: 'Inter',
    category: 'Modern Sans',
  },
  {
    id: 'lora',
    name: 'Lora',
    headingFont: 'Lora',
    bodyFont: 'Lato',
    category: 'Warm Serif',
  },
  {
    id: 'outfit',
    name: 'Outfit',
    headingFont: 'Outfit',
    bodyFont: 'Outfit',
    category: 'Contemporary',
  },
  {
    id: 'raleway',
    name: 'Raleway',
    headingFont: 'Raleway',
    bodyFont: 'Lato',
    category: 'Modern Sans',
  },
  {
    id: 'montserrat',
    name: 'Montserrat',
    headingFont: 'Montserrat',
    bodyFont: 'Open Sans',
    category: 'Geometric Sans',
  },
];

const TypographyPanel = () => {
  const { state, actions } = useWebsiteBuilder();
  const { draft } = state;

  const handleFontChange = (fontId) => {
    actions.updateDesign('fontStyle', fontId);
  };

  return (
    <div className="p-6 space-y-6">
      <div>
        <h3 className="text-lg font-semibold text-slate-900 mb-1">Typography</h3>
        <p className="text-sm text-slate-600">Choose a font style for your site</p>
      </div>

      <FontSelector
        selectedFontId={draft.design.fontStyle}
        onChange={handleFontChange}
        fontOptions={FONT_OPTIONS}
      />

      {/* Typography Tips */}
      <div className="mt-6 p-4 bg-purple-50 rounded-lg border border-purple-100">
        <h4 className="text-sm font-semibold text-purple-900 mb-2">Typography Tips</h4>
        <ul className="text-xs text-purple-800 space-y-1">
          <li>• Headings catch attention and set the tone</li>
          <li>• Body text should be easy to read for longer content</li>
          <li>• The pairing is applied consistently across your entire site</li>
        </ul>
      </div>
    </div>
  );
};

export default TypographyPanel;
